import React from 'react';
import { Hero } from './components/Hero';
import { Mission } from './components/Mission';
import { Gallery } from './components/Gallery';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#f4f1e8] overflow-x-hidden selection:bg-[#d4af37] selection:text-[#1a3a2e]" data-id="element-0">
      <Hero data-id="element-1" />
      <Mission data-id="element-2" />
      <Gallery data-id="element-3" />
      <Footer data-id="element-4" />
    </main>;
}